<!-- begin::Header Nav -->
<ul class="menu-nav">
    <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
        <a class="menu-link" [routerLink]="['/home']" [routerLinkActive]="['active']">
            <span class="menu-text" translate="MENU.DASHBOARD"><i class="fas fa-home"></i>Home</span>
        </a>
    </li>

    <!-- Organization Menu Item -->
    <ng-container *ngIf="isOrganizationVisible && routeid !== null; else addOrg">
        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active">
            <a class="menu-link" [routerLink]="['/management/edit-organization', currentOrgId || routeid]"
                [routerLinkActive]="['active']">
                <span class="menu-text" translate="MENU.DASHBOARD">Organization</span>
            </a>
        </li>
    </ng-container>

    <!-- Instance Menu Item -->
    <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active"
        *ngIf="isInstanceVisible && currentInstanceId && !router.url.includes('management/add-instance')">
        <a class="menu-link" [routerLink]="['/management/edit-instance', currentInstanceId]"
            [queryParams]="{ organizationId: currentOrgId }" [routerLinkActive]="['active']">
            <span class="menu-text">Instance</span>
        </a>
    </li>
</ul>
<!-- end::Header Nav -->

<ng-template #addOrg>
    <!-- Organization Menu Item for Add Mode -->
    <ul class="menu-nav">
        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active"
            *ngIf="isAddOrg && currentOrgId === null">
            <a class="menu-link" [routerLink]="['/management/add-organization']" [routerLinkActive]="['active']">
                <span class="menu-text" translate="MENU.DASHBOARD">Organization</span>
            </a>
        </li>

        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active"
            *ngIf="isAddOrg && currentOrgId !== null">
            <a class="menu-link" [routerLink]="['/management/edit-organization', currentOrgId]"
                [routerLinkActive]="['active']">
                <span class="menu-text" translate="MENU.DASHBOARD">Organization</span>
            </a>
        </li>

        <!-- Instance Menu Item for Add Mode -->
        <li class="menu-item menu-item-rel" routerLinkActive="menu-item-active"
            *ngIf="isAddInstance && currentOrgId && router.url.includes('management/add-instance')">
            <a class="menu-link" [routerLink]="['/management/add-instance']"
                [queryParams]="{ organizationId: currentOrgId }" [routerLinkActive]="['active']">
                <span class="menu-text">Instance</span>
            </a>
        </li>
    </ul>
</ng-template>